const __digiCustomJS__addToCartPopup_recoProducts = () => {
  const __popupRecoContent = document.querySelector(
    '#digi__add-to-cart__wrapper #digi__reco-products'
  );

  const __hiddenElements = () => {
    // Digi web buttons (mobile)
    document.querySelector('.digi-sticky-btn-container')?.setAttribute('hidden','');
    
    // Chat
    document.querySelector('.thulium-chat-wrapper')?.setAttribute('hidden', '');

    // Cookiebot
    document.querySelector('#CookiebotWidget')?.setAttribute('hidden', '');

    // Trustbadge
    document.querySelector('div[id*=trustbadge-container-]')?.setAttribute('hidden', '');
  };
  __hiddenElements();

  const __source = document.querySelector('.recommended-accessories-box');

  if (!__popupRecoContent || !__source) return;

  const __products = __source.querySelectorAll('.accessory-wrap.embla__slide');

  if (!__products.length) return;

  const __title = {
    title: __popupRecoContent.dataset.title,
    title2: __popupRecoContent.dataset.title2
  };

  __popupRecoContent.innerHTML = `
    <div class="recommended-accessories-box">
      <h4 class='__digi-desktop'>${__title.title}</h4>
      <h4 class='__digi-mobile'>${__title.title2}</h4>

      <div class="recommended-accessories">
        <div class="embla__viewport">
          <div class="embla__container"></div>
        </div>

        <div class="embla__controls">
          <button type="button" class="embla__prev" aria-label="Poprzednie produkty"></button>
          <div class="embla__dots"></div>
          <button type="button" class="embla__next" aria-label="Następne produkty"></button>
        </div>
      </div>
    </div>
  `;

  const __emblaRoot = __popupRecoContent.querySelector('.recommended-accessories');
  const __viewport = __popupRecoContent.querySelector('.embla__viewport');
  const __container = __popupRecoContent.querySelector('.embla__container');
  const __prevButton = __popupRecoContent.querySelector('.embla__prev');
  const __nextButton = __popupRecoContent.querySelector('.embla__next');
  const __dotsNode = __popupRecoContent.querySelector('.embla__dots');

  if (!__emblaRoot || !__viewport || !__container) return;

  __products.forEach((product) => {
    const __productClone = product.cloneNode(true);
    __productClone.removeAttribute('id');
    __productClone.removeAttribute('style');

    __productClone.querySelectorAll('[id]').forEach((node) => {
      node.removeAttribute('id');
    });

    __productClone.classList.add('embla__slide');
    __container.appendChild(__productClone);
  });

  requestAnimationFrame(() => {
    if (typeof EmblaCarousel !== 'function') {
      console.warn('EmblaCarousel nie jest dostępne.');
      return;
    }

    const __embla = EmblaCarousel(__viewport, {
      align: 'start',
      loop: false,
      dragFree: false,
      containScroll: "trimSnaps",
      slidesToScroll: "auto"
    });

    const __addDots = () => {
      if (!__dotsNode) return;

      __dotsNode.innerHTML = '';

      __embla.scrollSnapList().forEach((_, index) => {
        const __dot = document.createElement('button');

        __dot.type = 'button';
        __dot.className = 'embla__dot';
        __dot.setAttribute('aria-label', `Przejdź do slajdu ${index + 1}`);

        __dot.addEventListener('click', () => {
          __embla.scrollTo(index);
        });

        __dotsNode.appendChild(__dot);
      });
    };

    const __updateDots = () => {
      if (!__dotsNode) return;

      const __selectedIndex = __embla.selectedScrollSnap();

      __dotsNode.querySelectorAll('.embla__dot').forEach((__dot, index) => {
        __dot.classList.toggle('is-selected', index === __selectedIndex);
      });
    };

    const __updateButtons = () => {
      if (__prevButton) {
        __prevButton.disabled = !__embla.canScrollPrev();
      }

      if (__nextButton) {
        __nextButton.disabled = !__embla.canScrollNext();
      }
    };

    const __updateControls = () => {
      __updateDots();
      __updateButtons();
    };

    if (__prevButton) {
      __prevButton.addEventListener('click', () => {
        __embla.scrollPrev();
      });
    }

    if (__nextButton) {
      __nextButton.addEventListener('click', () => {
        __embla.scrollNext();
      });
    }

    __addDots();
    __updateControls();

    __embla.on('select', __updateControls);
    __embla.on('reInit', () => {
      __addDots();
      __updateControls();
    });

    __emblaRoot.__digiEmbla = __embla;
  });
};


class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.digiPopupWrapper = document.querySelector('#digi__add-to-cart__wrapper');

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.digiPopupWrapper?.classList.add('digi-active');
    document.body.classList.add('digi__fixed');
    
    __digiCustomJS__addToCartPopup_recoProducts();

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
